module.exports = __webpack_public_path__ + "static/media/W18-1011_AW_Free_RootBeer_mobile_hero_767x845_fr_v1.5bc29f71.jpg";